<template>
    <div class="game-form">
        <cell-box
            @click="handleClickFormItem(formItem)"
            :title="formItem.label"
            :formatter="formItem.formatter"
            :validator="formItem.validator"
            :placeholder="formItem.placeholder"
            :inputType="formItem.type"
            v-model="formItem.value"
            v-for="formItem in formData"
            :key="formItem.keyName"
            :readonly="formItem.type != 'input'"
            is-link
            clickable
        ></cell-box>
    </div>
</template>

<script>
import CellBox from './CellBox.vue';

export default {
    name: 'gameForm',
    props: {
        formData: [],
    },
    components: {
        CellBox,
    },
    methods: {
        handleClickFormItem(formItem) {
            this.$emit('click-form-item', formItem);
        },
    },
    computed: {},
};
</script>
